import React, { Fragment } from "react";
import logo from "../../logo.png";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../actions/auth";
import PropTypes from "prop-types";
const Navbar = ({ auth: { isAuthenticated, loading }, logout }) => {
  // Check state if user is Authenticated and show appropriate links
  // Add onClick on logout that logs user out and clears state

  const authLinks = (
    <nav className='navbar bg-dark'>
      <img
        className='hide-sm logo'
        src={logo}
        alt='logo'
        style={{ width: "50px" }}
      />
      <ul>
        <li>
          <Link to='/all-listings'>All Listings</Link>
        </li>
        <li>
          <Link to='/dashboard'>
            <i className='fas fa-user'></i>{" "}
            <span className='hide-sm'>Dashboard</span>
          </Link>
        </li>
        <li>
          <Link onClick={logout} to='/'>
            <i className='fas fa-sign-out-alt'></i>{" "}
            <span className='hide-sm'>Logout</span>
          </Link>
        </li>
        <h2>
          <Link to='/cart'>
            <i className='fa fa-shopping-cart' />
          </Link>
        </h2>
      </ul>
    </nav>
  );

  const guestLinks = <Fragment></Fragment>;

  return (
    <Fragment>
      {/* {isAuthenticated ? authLinks : guestLinks} */}
      {!loading && (
        <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>
      )}
    </Fragment>
  );
};

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Navbar);
